// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    ProgramModelResponse,
    ProgramModels,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class ProgramV2Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get an existing Program by Program identifier.
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programGetByProgramId (xProgramId?: number): Promise<AxiosResponse<ProgramModelResponse>> {
        const _url_ = '/program/v2/Program0726a8fb';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ProgramModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ProgramModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get Programs by Tenant Id or Program Code
     * @param programCode 
     * @param hasPromotion 
     * @param promotionId 
     */
    public async programGetByTenantId (programCode?: string, hasPromotion?: boolean, promotionId?: number): Promise<AxiosResponse<ProgramModels>> {
        const _url_ = '/program/v2/Programa634d9cb';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (programCode !== undefined) {
            _params_['programCode'] = Serializer.serialize(programCode, "string");
        }

        if (hasPromotion !== undefined) {
            _params_['hasPromotion'] = Serializer.serialize(hasPromotion, "boolean");
        }

        if (promotionId !== undefined) {
            _params_['promotionId'] = Serializer.serialize(promotionId, "number");
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ProgramModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ProgramModels");
        }
        return response;
    }
}
